import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Coinbase Wallet',
  },
};
